(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Agreements",
            {
                url: "/Agreements",
                component: "agreements"              
            });
        }
    ]);

    app.component("agreements",
    {
        templateUrl: "App/Agreements/Agreements.html",
        controller: agreementsController    
    });


    agreementsController.$inject = ["$mdToast", "$mdDialog", "$state", "$timeout"];


    function agreementsController($mdToast, $mdDialog, $state, $timeout) {
        var $ctrl = this;      
    }

    app.config(["$urlRouterProvider", function ($urlRouterProvider) {
        $urlRouterProvider.when("/Agreements", "/Home");
    }]);
  
})(window.app); // jshint ignore:line